export const TREE_MORE = 'TREE_MORE';
export const SCROLL_TOP = 'SCROLL_TOP';
export const SET_RESUME = 'SET_RESUME';
export const SET_RESUME_TYPE = 'SET_RESUME_TYPE';


// WEBPACK FOOTER //
// ./src/store/mutations-types.js